/**
 * Tools switched off in code for every workspace (owner ruling 2026-10-09: AHP).
 *
 * A tool listed here is not offered anywhere: the Tools page, session tool
 * pickers, recommendations, saved configurations, the command palette and the
 * Modules settings list all leave it out, and its standalone page redirects to
 * the Tools page. There is no workspace switch for it.
 *
 * Sessions already run with the tool keep opening and keep their results — the
 * tool's component and registry entries stay, so nothing saved is lost. To
 * bring a tool back, remove it from this list.
 *
 * This file imports nothing so any registry can read it.
 */
export const SWITCHED_OFF_TOOL_IDS: readonly string[] = ['ahp'];

const normalize = (toolId: string): string => toolId.trim().toLowerCase().replace(/_/g, '-');

const SWITCHED_OFF_TOOL_ID_SET = new Set(SWITCHED_OFF_TOOL_IDS.map(normalize));

/** True when the tool is switched off in code. Accepts 'ahp', 'AHP', and '_' or '-' spellings. */
export function isToolSwitchedOff(toolId: string | null | undefined): boolean {
  if (!toolId) return false;
  return SWITCHED_OFF_TOOL_ID_SET.has(normalize(toolId));
}

/** Drops switched-off tools from a list of tool ids. */
export function withoutSwitchedOffTools<T extends string>(toolIds: readonly T[]): T[] {
  return toolIds.filter((id) => !isToolSwitchedOff(id));
}
